import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SalesMetrosService } from '../services';
import { salesMetrosKeys } from '../queryKeys';

/**
 * Replaces one metro's assigned admins, then refreshes the list so the row
 * shows what organization-service stored rather than a guess.
 *
 * `mutate(internalUserIds, { onSuccess, onError })`. Callers pass their
 * callbacks per call, not here: the edit dialog is mounted only while open, and
 * a hook-level callback would still fire after an admin closed it mid-request.
 */
export const useSetSalesMetroAdmins = (salesMetroId) => {
  const queryClient = useQueryClient();

  return useMutation({
    // The dialog renders the service's `error` inline. organization-service
    // bodies carry `error`, so the global toaster would show the same sentence
    // a second time.
    meta: { skipGlobalErrorToaster: true },
    mutationFn: (internalUserIds) =>
      SalesMetrosService.setSalesMetroAdmins(salesMetroId, internalUserIds),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: salesMetrosKeys.list() }),
  });
};
